import { createTrackingPageProvider } from '@edreamsodigeo/frontend-core';
const CHECKOUT_FLIGHT_SUMMARY_META_PAGE_CATEGORY = 'checkout_flight_summary_meta';
const CHECKOUT_FLIGHT_SUMMARY_META_PAGE = '/flights/checkout_flight_summary_meta/';
const CheckoutFlightSummaryMetaTrackingProvider = createTrackingPageProvider({
  category: CHECKOUT_FLIGHT_SUMMARY_META_PAGE_CATEGORY,
  pageMapper: () => CHECKOUT_FLIGHT_SUMMARY_META_PAGE,
  pageViewName: 'summary'
});
export default CheckoutFlightSummaryMetaTrackingProvider;